import { styled } from '@mui/system';
import MenuItem from '@mui/material/MenuItem';
import CircularProgress from '@mui/material/CircularProgress';
import { getContrastColor } from '#component/theme';

const disableColor = 'rgba(0, 0, 0, 0.32)';

export const Icon = styled('span')(({ theme }) => ({
  color: getContrastColor(),
  marginRight: theme.spacing(),
  display: 'flex',
  alignItems: 'center'
}));

export const DisabledIcon = styled('span')(({ theme }) => ({
  color: disableColor,
  marginRight: theme.spacing(),
  display: 'flex',
  alignItems: 'center'
}));

export const IconSecond = styled('span')(({ theme }) => ({
  color: 'rgba(0, 0, 0, 0.54)',
  marginRight: theme.spacing(),
  display: 'flex',
  alignItems: 'center'
}));

export const StyledMenuItem = styled(MenuItem)({
  minWidth: 160
});

export const DisabledText = styled('span')({
  color: disableColor
});

export const Preloader = styled(CircularProgress)(({ theme }) => ({
  color: disableColor,
  marginRight: theme.spacing() + 2,
  marginLeft: 2
}));

export const AlertPreloader = styled(CircularProgress)({
  color: disableColor
});

export const AlertStatusCnt = styled('span')({
  display: 'flex',
  minWidth: 24,
  minHeight: 24,
  width: 24,
  height: 24,
  alignItems: 'inherit',
  justifyContent: 'center'
});
